<vn-dynamic-layout-slot slot="inner-navigation"></vn-dynamic-layout-slot>
<div id="main-view"><router-outlet (activate)="setMainVisible()"></router-outlet></div>
<ms-content-box></ms-content-box>
<vn-dynamic-layout-slot slot="inner-footer"></vn-dynamic-layout-slot>
